import React from 'react'
import './ui.css'

const ROLE_CONFIG = {
  admin: { label: 'Администратор', variant: 'admin' },
  management: { label: 'Руководство', variant: 'management' },
  department_head: { label: 'Руководитель', variant: 'head' },
  accountant: { label: 'Бухгалтер', variant: 'accountant' },
  employee: { label: 'Сотрудник', variant: 'employee' }
}

/**
 * Бейдж роли пользователя. Варианты: admin, management, department_head, accountant, employee.
 * Единый вид по дизайн-системе (цвета и типографика).
 */
function RoleBadge({ role, className = '' }) {
  const config = ROLE_CONFIG[role] || ROLE_CONFIG.employee
  const variantClass = `ui-role-badge-${config.variant}`
  return (
    <span
      className={`ui-role-badge ${variantClass}` + (className ? ` ${className}` : '')}
      role="status"
      aria-label={`Роль: ${config.label}`}
    >
      {config.label}
    </span>
  )
}

export default RoleBadge
